import React from 'react';

/** Timeline / path icon for milestone completion modal triggers */
export const MilestonePathIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <circle cx="6" cy="6" r="2" />
    <circle cx="6" cy="18" r="2" />
    <circle cx="18" cy="12" r="2" />
    <path d="M6 8v8" />
    <path d="M8 6h5a3 3 0 0 1 3 3v0a3 3 0 0 0 3 3h2" />
  </svg>
);

export default MilestonePathIcon;
